const BankAccountGetter = {
    bankAccounts: (state) => state.bankAccounts,
    banks: state => state.banks,
    banksWithUSSD: state => state.banksWithUSSD
};

export default BankAccountGetter;